export default __webpack_public_path__ + "assets/images/e5ab77421fcaefbf0a33b06f45e6dac7.png";